import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { SubscriptionListType } from '~/shared/constants/commonConstants'
import { ScreenName } from '~/shared/services/eventLogger'
import { setScreenNameAction } from '~/shared/store/common/actions'
import {
  getSubscriptionListAction,
  setSelectedSubscriptionAction,
  setSubscriptionListAction,
} from '~/shared/store/subscription/actions'
import { selectSubscriptionList } from '~/shared/store/subscription/selects'

type TParams = {
  tags: string
  screenName: ScreenName
  subscriptionType: typeof SubscriptionListType[keyof typeof SubscriptionListType]
}

export const useGetSubscriptions = ({
  tags,
  screenName,
  subscriptionType,
}: TParams) => {
  const dispatch = useDispatch()
  const subscriptionsList = useSelector(selectSubscriptionList)

  useEffect(() => {
    dispatch(setSubscriptionListAction([]))
    dispatch(setScreenNameAction(screenName))
    dispatch(
      getSubscriptionListAction({
        tags,
        subscriptionType,
      }),
    )

    return () => {
      dispatch(setSubscriptionListAction([]))
    }
  }, [dispatch, screenName, subscriptionType, tags])

  useEffect(() => {
    const defaultSubscription =
      subscriptionsList.find(({ isDefault }) => !!isDefault) ||
      subscriptionsList[0]

    dispatch(setSelectedSubscriptionAction(defaultSubscription))

    return () => {}
  }, [dispatch, subscriptionsList])
}
